export default __webpack_public_path__ + "static/media/i249vp.05ab9c90.webp";